export enum ACTIONS
{
    MESSAGE = 0,
    GAMEDATA = 1,
    PLAYERJOIN = 2,
    PLAYERLEFT = 3,
    PLAYERVARS = 4,
    SYNCREQUEST = 5,
    GAMESTART = 6,
    ROOMREADY = 7,
    ROOMSTATUS = 8,
    PLAYERSTATUS = 9,
    TIME = 10,
    TIMER = 11,
    LOADING = 12,
    PLAYERSTATE = 13,
    INSYNC = 14,
    ENTRY = 15,
    CALL_ACTION = 16,
    CALL_ACCEPT = 17,
    CALL_CANCEL = 18,
    AUTH_SET = 19,
    AUTH_GET = 20,
    FILE_SET = 21,
    FILE_GET = 22,
    ROOM_SET = 23,
    ROOM_GET = 24,
    ROOM_GETONE = 25,
    ROOM_ENTRIES_GET = 26,
    ROOM_ENTRIES_SET = 27,
    ROOM_ENTRIES_CHANGE = 28,
    ROOM_ENTRIES_REMOVE = 29,
    FRIENDS_GET = 30,
    FRIENDS_SET = 31,
    FRIENDS_CHANGE = 32,
    FRIENDS_REMOVE = 33,
    CHAT = 34,
    ANALYTICS_SET = 35,
    ANALYTICS_GET = 36,
    FOLLOWERS_GET = 37,
    FOLLOWERS_SET = 38,
    FOLLOWERS_REMOVE = 39,
    GAME_GETONE = 40,
    GAME_GET = 41,
    GAME_DATA_GET = 42,
    GAME_DATA_SET = 43,
    GAME_SCORE_SET = 44,
    GAME_SCORE_GET = 45,
    GAME_SCORE_GETALLTIME = 46,
    GAME_SCORE_GETTODAY = 47,
    GAME_SCORE_GETFRIENDSALLTIME = 48,
    GAME_SCORE_GETFRIENDSTODAY = 49,
    MATCHMAKING = 50,
    SCOREBOARD_GET = 51,
    SCOREBOARD_ENTRIES_SET = 52,
    GAME_TURN_SET = 53,
    GAME_TURN_GET = 54,
    GAME_TURN_GETONE = 55,
    GAME_TURN_CHANGE = 56,
    GAME_SHOP_GET = 57,
    GAME_SHOP_SET = 58,
    GAME_PLAYERINVENTORY_BUY = 59,
    GAME_PLAYERINVENTORY_GET = 60,
    GAME_PLAYERINVENTORY_CHANGE = 61,
    GAME_PLAYERINVENTORY_REMOVE = 62,
    GAME_CURRENCY_GET = 63,
    GAME_CURRENCY_GETONE = 64,
    GAME_CURRENCY_CHANGE = 65,
    GAME_DAILYREWARDS_GET = 66,
    GAME_DAILYREWARDS_SET = 67,
    INSTANCE_GETONE = 68,
    INSTANCE_GET = 69,
    TAG_ASSOCIATIONS_GET = 70,
    TAG_ASSOCIATIONS_SET = 71,
    JUDGEMENT_GETONE = 72,
    JUDGEMENT_SET = 73,
    STATS_CHANGE = 74,
    AVATAR_GET = 75,
    AVATAR_GETONE = 76,
    WALLET_GETSET = 77,
    WALLET_HISTORY_GET = 78,
    WALLET_ASSETS_GET = 79,
    WALLET_SEND = 80,
    SOCIAL_TWITTER_SHARE = 81,
    SOCIAL_GOOGLE_SHARE = 82,
    SOCIAL_GOOGLE_SHARE_GET = 83,
    SOCIAL_DISCORD_SHARE = 84,
    SOCIAL_DISCORD_SHARE_GET = 85,
    EMAIL_SEND = 86,
    NFT_COLLECTION_GET = 87,
    NFT_COLLECTION_MINT = 88,
    NFT_TOKEN_GET = 89,
    NFT_TOKEN_REMOVE = 90,
    NFT_TOKEN_CHANGE = 91,
    NFT_HISTORY_GET = 92,
    GAME_DATA_REMOVE = 93,
    GAME_TURN_REMOVE = 94,
    GAME_SET = 95,
    AVATAR_PHOTO_SET = 96,
    AVATAR_PHOTO_GET = 97,
    SNAPPY_SET = 98,
    SNAPPY_GETONE = 99,
    BOT_GET = 100,
    BOT_SET = 101,
    GAME_MISSIONS_SET = 102,
    GAME_MISSIONS_GET = 103,
    SCOREBOARD_ENTRIES_GET = 104,
    AUTH_VERIFY = 105,
    AUTH_RESEND_VERIFY = 106,
    AUTH_RESET_PASSWORD = 107,
    AUTH_CHANGE_PASSWORD = 108,
    AUTH_RESEND_RESETKEY = 109,
    AVATAR_CHANGE = 110,
    EMAIL_CHANGE = 111,
    EMAIL_GETONE = 112,
    USERNAME_GETONE = 113,
    EMAIL_EXISTS = 114,
    USERNAME_GET = 115,
    EMAIL_CREATE = 116,
    CHAT_ICECANDIDATE = 117,
    CHAT_VIDEO_CHANGE = 118,
    CHAT_MUTE_CHANGE = 119,
    USERNAME_PROXY_GET = 120,
    SHARE_GET = 121,
    SHARE_GETONE = 122,
    SHARE_SET = 123,
    GAME_GETDATA = 124,
    GAME_MESSAGES_GET = 125,
    GAME_MESSAGES_SET = 126,
    GAME_MESSAGES_CHANGE = 127,
    GAME_MESSAGES_REMOVE = 128,
    PHONE_SEND = 129,
    PHONE_CHANGE = 130,
    PHONE_GETONE = 131,
    PHONE_SET = 132,
    PHONE_EXISTS = 133,
    POST_SET = 134,
    POST_CHANGE = 135,
    POST_GET = 136,
    POST_GETONE = 137,
    FEED_GET = 138,
    FEED_GETONE = 139,
    FOLLOWERS_GETONE = 140,
    BIO_GETONE = 141,
    BIO_SET = 142,
    CONTACTS_GET = 143,
    CONTACTS_SET = 144,
    AVATAR_SOCKET_SET = 145,
    AVATAR_SOCKET_REMOVE = 146,

    ROOM_ENTRY_REACTIONS_SET = 147,

    USERNAME_EXISTS  = 148,

    PROFILE_GET = 149,
    PROFILE_SET = 150,

    FRIENDS_SEARCH = 151,

    TYPING = 152,

    ROOM_ENTRIES_READ_GET = 153,
    ROOM_ENTRIES_READ_SET = 154,

    EDIT = 155,
    REMOVE = 156,
    REPLY = 157,
    QUOTE = 158,
    EMOJI = 159,

    ROOM_ENTRY_REACTIONS_GET = 160,
    CALL_CANDIDATE = 161,
    INVITE_GET = 162,
    INVITE_SET = 163,
    AUTH_REMOVE = 164,
    PET_GET = 165,
    PET_ENTRY_SET = 166,
    PET_ROOM_SET = 167,

    NOTIFICATION_SET = 168,

    REALTIME_ONMESSAGE = 169,

    COLYSEUS_ECHO = 170,
}

export enum STATUS
{
    LOBBY 			= 0,
	WAITING 		= 1,
	COUNTDOWN 		= 2,
	PLAYING 		= 3,
	OVER 		    = 4,
	PLAYERSREADY 	= 5,
    RESET           = 6,
    READY           = 7,
    REWARDED        = 8,
    BUSY            = 9,
    SENT            = 10,
    INBOX           = 11,
    ACTIVE          = 12,
    NORESPONSE      = 13,
    VICTORY         = 14,
    DEFEAT          = 15,
    FINISH          = 16,
    VIEW            = 17,
    AUTO            = 18,
}

export enum STATE
{
    IDLE 			= 0,
	JUMP 		    = 1,
	ATTACK 		    = 2,
	DYING 		    = 3,
	DEAD 		    = 4,
	SPAWN 	        = 5,
    DANCE           = 6,
    DEFEAT          = 7,
    CARRY           = 8,
    WALK            = 9,
    RUN             = 10,
    CRAZY           = 11,
    FALL            = 12,
    WALLRUN         = 13,
    SLIDE           = 14,
    WALLSLIDE       = 15,
    DOUBLEJUMP      = 16
}

export enum  TYPES
{
  ENTRY             = 0,
  TYPING            = 1,
  SEPARATOR         = 2,
  IMAGE             = 3,
  VIDEO             = 4,
  MEDIA             = 5,
  AUDIO             = 6,
  UNKNOWN           = 7,
  CALL              = 8,
  GAME              = 9,
  VS                = 10,
  ASYNC             = 11,
  ME                = 12,
  RIVAL             = 13,
  FRIENDS           = 14,
  AVATAR            = 15,
}

export enum FRIEND_STATUS
{
    UKNOWN = 'uknown',
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    ACTIVE = 'active',
    INVITED = 'invited'
}